import { Link, useLocation } from "react-router-dom";
import "./singlePost.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../context/AuthContext";
import { getToken } from "../../helpers/authHelpers";
import { useNavigate } from "react-router-dom";
import ShareSocial from "../shareSocial/ShareSocial";
import ArticleContent from "../articlecontent/ArticleContent";

export default function SinglePost() {
  const { user } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split("/")[2];
  // console.log("Path:", path);
  const [post, setPost] = useState({});

  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false); // Optional: prevent multiple likes per session

  const handleLike = async () => {
    if (liked) return; // Prevent double-click

    try {
      const updatedLikes = likes + 1;
      let likeRes = await axios.put(
        `${process.env.REACT_APP_API_URL}/posts/${post.id}/like`,
        {
          data: {
            likes: updatedLikes,
          },
        },
      );

      setLikes(likeRes.data.likes);
      setLiked(true);
    } catch (err) {
      console.error("Failed to like post:", err);
    }
  };
  // console.log(post);
  useEffect(() => {
    const getPost = async () => {
      const res = await axios.get(
        process.env.REACT_APP_API_URL +
          "/posts/" +
          path +
          "?populate[photo]=true&populate[categories]=true&populate[author][populate]=author_img",
        // {
        //   headers: {
        //     Authorization: "bearer " + process.env.REACT_APP_API_KEY,
        //   },
        // }
      );
      setPost(res.data.data);
      setLikes(res.data.data.likes);
    };
    getPost();
  }, [path]);

  const handleDeletePost = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this post?",
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/posts/${post.documentId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        },
      );

      console.log("Post deleted successfully.");
      navigate("/"); // or wherever you want to redirect after deletion
    } catch (err) {
      console.error(
        "Failed to delete post:",
        err.response?.data || err.message,
      );
      console.log("Failed to delete post.");
    }
  };

  return (
    <div className="singlePost">
      <div className="singlePostWrapper">
        <h1 className="singlePostTitle no-text-shadow">{post.title}</h1>

        <div className="d-flex w-100 justify-content-between align-items-center py-2">
          <div className="authorInfo d-flex align-items-center gap-1">
            <b className="singlePostAuthor">
              <Link
                className="link"
                to={`/posts?author=${post.author?.documentId}`}
              >
                {post.author?.name}
              </Link>
            </b>
            {post.photo && (
              <Link
                to={`/posts?author=${post.author?.documentId}`}
                className="link"
              >
                <img
                  className="topImg"
                  src={`${process.env.REACT_APP_UPLOAD_URL}${
                    post.author?.author_img?.formats?.thumbnail?.url ||
                    post.author?.author_img?.url
                  }`}
                  alt=""
                />
              </Link>
            )}
          </div>
          <Link to={`/posts?createdAt=${post.createdAt}`} className="link">
            <span className="postDate">
              {" "}
              {new Date(post.createdAt).toDateString()}
            </span>
          </Link>
        </div>

        <div
          className="d-flex align-items-center justify-content-start bg-cover bg-center text-white position-relative sPostImg"
          style={{
            backgroundImage: `url(${process.env.REACT_APP_UPLOAD_URL}${post.photo?.url})`,

            backgroundPosition: "center",
          }}
        >
          {/* <div className="d-flex flex-column z-3 position-relative ps-5">
            <h1>{post.title}</h1>
          </div> */}
        </div>

        {/* {post.photo && (
          <img
            className="singlePostImg"
            src={`${process.env.REACT_APP_UPLOAD_URL}${post.photo?.url}`}
            alt=""
          />
        )}

         */}

        <div className="singlePostInfo">
          <div className="postCats">
            {post.categories?.map((c, index) => (
              <span key={`postCat${index}`} className="postCat">
                <Link className="link" to={`/posts?cat=${c.documentId}`}>
                  {c.name}
                </Link>
              </span>
            ))}
          </div>

          {user ? (
            <div className="d-flex flex-row singlePostEdit align-items-center gap-3">
              <Link to={`/write/${post.documentId}`}>
                <div className="">
                  <i className="singlePostIcon fa-solid fa-pen-to-square"></i>
                </div>
              </Link>

              <button
                className="deleteBtn"
                type="button"
                onClick={handleDeletePost}
              >
                <i className="fa-solid fa-trash-can"></i>
              </button>
            </div>
          ) : (
            <div className="postStats d-flex flex-row singlePostEdit">
              <span
                className="stat like "
                onClick={handleLike}
                title="Like this post"
              >
                {liked ? (
                  <i className="fa-solid fa-heart liked"></i>
                ) : (
                  <i className="fa-regular fa-heart clickable"></i>
                )}{" "}
                {likes}
              </span>
            </div>
          )}
        </div>

        {/* <div className="w-100 d-flex justify-content-end">
          <ShareSocial post={post} shareUrl={""} shareTitle={""} />
        </div> */}
      </div>
      <p className="singlePostDesc">{post.description}</p>

      <ArticleContent content={post.richtext} />
    </div>
  );
}
